
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

const APP_FIREBASE = import.meta.env.VITE_FIREBASE;

if (!APP_FIREBASE) {
  throw new Error(
    "Missing VITE_FIREBASE. Check your production build environment."
  );
}

const firebaseConfig = {
  apiKey: APP_FIREBASE,
  authDomain: "forumde-16307.firebaseapp.com",
  projectId: "forumde-16307",
  storageBucket: "forumde-16307.firebasestorage.app",
  messagingSenderId: "839676330554",
  appId: "1:839676330554:web:4bf892d92169d2b8e36b03",
  measurementId: "G-G8Y2NH1E4Z",
};

const app = getApps().length
  ? getApp()
  : initializeApp(firebaseConfig);

const fireDB = getFirestore(app);
const rtdb = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { fireDB, auth, storage, rtdb, app };
